export const NavigationKey = {
  BusinessUnitInformation: "information",
  Members: "members",
};
